module.exports = __webpack_public_path__ + "assets/img/free_27.46508d0b.png";